import { render, staticRenderFns } from "./COD.vue?vue&type=template&id=b4bde632&"
import script from "./COD.vue?vue&type=script&lang=js&"
export * from "./COD.vue?vue&type=script&lang=js&"
import style0 from "./COD.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports